import { render } from "./reciboDialog.vue?vue&type=template&id=b247adb0&scoped=true"
import script from "./reciboDialog.vue?vue&type=script&lang=js"
export * from "./reciboDialog.vue?vue&type=script&lang=js"

import "./reciboDialog.vue?vue&type=style&index=0&id=b247adb0&scoped=true&media=print&lang=css"
import "./reciboDialog.vue?vue&type=style&index=1&id=b247adb0&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.41_vue@3.5.41_webpack@5.109.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b247adb0"]])

export default __exports__